<template>
  <v-container grid-list-lg>
    <v-layout v-bind='binding'>
      <v-flex xs12 lg6 order-lg2 class='ma-3'>
        <v-card>
          <v-card-title class='headline font-weight-regular oem-color'>
            Select CT
            <v-spacer/>
            <v-btn
              flat
              class='transparent ma-0'
              @click='$refs.legend.show()'
              icon
              small
            >
              <v-icon class='white--text oem-color'>
                help_outline
              </v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
          <helpLegend ref='legend' page='CT'></helpLegend>
          <div class='img-overlay'>
            <device-image type='ct'></device-image>
            <div
              v-for='(input, index) in this.storeState.data.allCts'
              :key='index'
              :style='buttonLocation(index)'
              class='button-holder'
            >
              <selector
                :state='ctState(input)'
                :index='index'
                :selected='index === storeState.selectedCt.channel - 6'
                :text='index+1'
                v-on:selector-clicked='showCt'
              ></selector>
            </div>
          </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <transition name='slide-x-transition'>
        <v-flex xs12 lg6 class='ma-3'>
          <v-card>
            <v-card-title class='headline font-weight-regular oem-color'>
              <template v-if='isNaN(storeState.selectedCt.channel)'>
              CT Configuration
              </template>
              <template v-else>
                CT {{ storeState.selectedCt.channel - 5 }} Configuration
              </template>
            </v-card-title>
            <v-card-text>
              <div class='ma-3'>
                <v-layout row align-center>
                  <v-flex xs5>
                    <v-list>
                      <v-list-tile v-if='selectedLoad != -1'>
                        <v-list-tile-content class='oem-quaternary-text-color'>
                          Load
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-list-tile v-if='selectedLoad != -1'>
                        <v-list-tile-content class='oem-quaternary-text-color'>
                            Voltage input
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-list-tile v-if='selectedLoad != -1'>
                        <v-list-tile-content class='oem-quaternary-text-color'>
                          Voltage reference
                        </v-list-tile-content>
                      </v-list-tile>
                      <!-- <v-list-tile>
                        <v-list-tile-content class='oem-quaternary-text-color'>
                            Configuration state
                        </v-list-tile-content>
                      </v-list-tile> -->
                    </v-list>
                  </v-flex>
                  <v-flex xs7>
                      <v-list>
                        <v-list-tile v-if='selectedLoad != -1'>
                          <v-list-tile-content>
                            {{ this.selectedLoad.name }}
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile v-if='selectedLoad != -1'>
                          <v-list-tile-content>
                            {{ this.selectedLoad.input + 1 }}
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile v-if='selectedLoad != -1'>
                          <v-list-tile-content>
                              {{ 'L' + ctPhase }}
                          </v-list-tile-content>
                        </v-list-tile>
                        <!-- <v-list-tile>
                          <v-list-tile-content>
                            {{ storeState.data.allCts[selectedCt].unsaved ?
                              'Configured' : 'Unconfigured' }}
                          </v-list-tile-content>
                        </v-list-tile> -->
                      </v-list>
                  </v-flex>
                  </v-layout>
                <v-form ref='form' v-model='valid' lazy-validation>
                  <v-select
                    v-model='storeState.selectedCt.type'
                    :items='storeState.ctTypes'
                    label='CT type'
                    v-validate="'required'"
                    data-vv-name="storeState.ctTypes"
                    :error-messages="errors.collect('storeState.ctTypes')"
                    @change='updateTypeName()'
                  ></v-select>
                  <!-- <v-text-field
                    v-if='ctType === "custom"'
                    label='CT type'
                    v-model='storeState.data.allCts[selectedCt].typeName'
                    v-validate="'required'"
                    data-vv-name="type name"
                    counter
                    maxlength="50"
                    :error-messages="errors.collect('type name')"
                    class='pt-4'
                    @input='save'
                    required
                  ></v-text-field> -->
                  <v-text-field
                    v-if='ctType === "custom"'
                    label='Rated current (A)'
                    v-model='storeState.selectedCt.maxRating'
                    v-validate="'required|decimal|min_value:10|max_value:10000'"
                    data-vv-name="rated current"
                    :error-messages="errors.collect('rated current')"
                    class='pt-4'
                    @input='unconfigure'
                    required
                  ></v-text-field>
                  <v-text-field
                    v-if='ctType === "custom"'
                    label='Voltage at rated current (mV)'
                    v-model='storeState.selectedCt.maxOutput'
                    v-validate="'required|decimal|min_value:10|max_value:2000'"
                    data-vv-name="voltage at rated current"
                    :error-messages="errors.collect('voltage at rated current')"
                    class='pt-4'
                    @input='unconfigure'
                    required
                  ></v-text-field>
                  <v-text-field
                    v-if='ctType === "clamp"'
                    label='Rated current (A)'
                    disabled
                    :value='maxCurrent'
                    class='pt-4'
                  ></v-text-field>
                  <v-text-field
                    v-if='ctType === "clamp"'
                    label='Voltage at rated current (mV)'
                    disabled
                    :value='maxVoltage'
                    class='pt-4'
                  ></v-text-field>
                  <v-text-field
                    v-if='ctType === "rogo"'
                    label='Max current allowed (A)'
                    disabled
                    :value='maxCurrent'
                    class='pt-4'
                  ></v-text-field>
                  <v-text-field
                    v-if='ctType === "rogo"'
                    label='Sensitivity (mV/kA)'
                    disabled
                    :value='maxVoltage'
                    class='pt-4'
                  ></v-text-field>
                  <!-- <v-text-field
                    v-if='ctType === "clamp" || ctType === "custom"'
                    label='Phase Correction (°)'
                    v-model='storeState.selectedCt.phaseCorrection'
                    v-validate="'required|decimal'"
                    data-vv-name="phase correction"
                    :error-messages="errors.collect('phase correction')"
                    class='pt-4'
                    @input='unconfigure'
                    required
                  ></v-text-field> -->
                </v-form>
                <v-switch
                  v-model='storeState.selectedCt.inverse'
                  label='CT polarity correction'
                ></v-switch>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-btn
                class='oem-button'
                flat
                @click='copyDialog()'
              >
                Copy
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                class='oem-button'
                flat
                @click='save'
              >
                Save
              </v-btn>
              <v-btn
                class='oem-button'
                flat
                @click='clear'
              >
                Defaults
              </v-btn>
            </v-card-actions>
          </v-card>
          <v-dialog v-model='dialog' persistent max-width='500px'>
            <v-card>
              <v-card-title class='headline font-weight-regular oem-color'
                >Select CT's to paste CT configuration
              </v-card-title>

              <v-card-text>
                <v-form v-model='valid' ref='copySelect' lazy-validation>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-select
                          v-model='selectedCopyCts'
                          :items='copyItems'
                          multiple
                          chips
                          class='oem-text-color'
                          label="Select CT's"
                          ref='select'
                          deletable-chips
                        >
                          <template v-slot:prepend-item>
                            <div>
                              <v-btn
                                class='oem-button'
                                flat
                                @click='closeCopySelect(true)'
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                class='oem-button'
                                flat
                                @click='closeCopySelect(false)'
                              >
                                Ok
                              </v-btn>
                            </div>
                            <v-list-tile
                              ripple
                              @click="toggleSelection"
                            >
                              <v-list-tile-action>
                                <v-icon class='oem-text-color'>
                                  {{ icon }}
                                </v-icon>
                              </v-list-tile-action>
                              <v-list-tile-title>
                                Select {{ copyAll ? 'none' : 'all' }}
                              </v-list-tile-title>
                            </v-list-tile>
                            <v-divider class="mt-2"></v-divider>
                          </template>
                        </v-select>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class='oem-button' flat @click='dialog = false'>Cancel</v-btn>
                <v-btn
                  class='oem-button'
                  flat
                  :disabled='!valid'
                  @click='copySelect()'
                >
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-flex>
      </transition>
    </v-layout>
  </v-container>
</template>

<script>
import { Validator } from 'vee-validate';
import selector from './BaseSelector.vue';
import helpLegend from './BaseLegend.vue';
import deviceImage from './BaseDeviceImage.vue';

Validator.extend('ctType', {
  getMessage: 'Please select a CT type.',
  validate(value) {
    return value !== 0;
  },
});
Validator.extend('vdi', {
  getMessage: 'This VDI address is already in use.',
  validate(value, args) {
    return value === '' || args.vdis.indexOf(value) === -1;
  },
});

export default {
  name: 'CT',
  components: {
    selector,
    helpLegend,
    deviceImage,
  },

  computed: {
    binding() {
      const binding = {};

      if (this.$vuetify.breakpoint.mdAndDown) binding.column = true;

      return binding;
    },
    icon() {
      if (this.selectedCopyCts.length === this.copyItems.length) return 'check_box';
      if (this.selectedCopyCts.length > 0) return 'indeterminate_check_box';
      return 'check_box_outline_blank';
    },
    maxCurrent() {
      if (typeof this.storeState.selectedCt.type === 'undefined') {
        return 0;
      }
      return this.storeState.ctTypes[this.storeState.selectedCt.type].maxCurrent;
    },
    ctType() {
      if (typeof this.storeState.selectedCt.type === 'undefined') {
        return 'none';
      }
      return this.storeState.ctTypes[this.storeState.selectedCt.type].type;
    },
    maxVoltage() {
      if (typeof this.storeState.selectedCt.type === 'undefined') {
        return 0;
      }
      return this.storeState.ctTypes[this.storeState.selectedCt.type].maxVoltage;
    },
    customCt() {
      if (this.storeState.selectedCt.type === 9) {
        return true;
      }
      return false;
    },
  },
  data() {
    return {
      storeState: this.$store.state,
      selectedLoad: -1,
      ctPhase: -1,
      valid: true,
      dialog: false,
      copyItems: [],
      selectedCopyCts: [],
      copyAll: false,
      ctTypes: [
        { text: 'None', value: 0 },
        { text: 'CTS-020 (20 Amp)', value: 1 },
        { text: 'CTS-050 (50 Amp)', value: 2 },
        { text: 'CTS-100 (100 Amp)', value: 3 },
        { text: 'CTS-200 (200 Amp)', value: 4 },
        { text: 'CTS-400 (400 Amp)', value: 5 },
        { text: 'CT-PF-12 (1500 Amp)', value: 6 },
        { text: 'CT-PF-24 (3000 Amp)', value: 7 },
        { text: 'CT-PF-36 (6000 Amp)', value: 8 },
        { text: 'User defined', value: 9 },
      ],
      selectRules: [v => !!v || 'Field is required'],
      styles: ['green--text ', 'red--text ', 'orange--text ', 'grey--text '],
      legend: ['Fully configured', 'Used by load but unconfigured', 'Configured but not used by any load', 'Unused'],
      helpDialog: false,
      buttonLocation12: [
        { top: '13.0%', left: '91.8%' },
        { top: '23.1%', left: '91.8%' },
        { top: '33.3%', left: '91.8%' },
        { top: '43.4%', left: '91.8%' },
        { top: '53.5%', left: '91.8%' },
        { top: '63.6%', left: '91.8%' },
        { top: '13.0%', left: '8.5%' },
        { top: '23.1%', left: '8.5%' },
        { top: '33.3%', left: '8.5%' },
        { top: '43.4%', left: '8.5%' },
        { top: '53.5%', left: '8.5%' },
        { top: '63.6%', left: '8.5%' },
      ],
      buttonLocation48: [
        { top: '5.15%', left: '78%' },
        { top: '9.20%', left: '78%' },
        { top: '13.25%', left: '78%' },
        { top: '17.30%', left: '78%' },
        { top: '21.35%', left: '78%' },
        { top: '25.35%', left: '78%' },

        { top: '5.15%', left: '22%' },
        { top: '9.20%', left: '22%' },
        { top: '13.25%', left: '22%' },
        { top: '17.30%', left: '22%' },
        { top: '21.35%', left: '22%' },
        { top: '25.35%', left: '22%' },

        { top: '38.50%', left: '78%' },
        { top: '42.55%', left: '78%' },
        { top: '46.60%', left: '78%' },
        { top: '52.65%', left: '78%' },
        { top: '56.70%', left: '78%' },
        { top: '60.75%', left: '78%' },
        { top: '66.80%', left: '78%' },
        { top: '70.85%', left: '78%' },
        { top: '74.90%', left: '78%' },

        { top: '38.50%', left: '53%' },
        { top: '42.55%', left: '53%' },
        { top: '46.60%', left: '53%' },
        { top: '52.65%', left: '53%' },
        { top: '56.70%', left: '53%' },
        { top: '60.75%', left: '53%' },
        { top: '66.80%', left: '53%' },
        { top: '70.85%', left: '53%' },
        { top: '74.90%', left: '53%' },

        { top: '38.50%', left: '47%' },
        { top: '42.55%', left: '47%' },
        { top: '46.60%', left: '47%' },
        { top: '52.65%', left: '47%' },
        { top: '56.70%', left: '47%' },
        { top: '60.75%', left: '47%' },
        { top: '66.80%', left: '47%' },
        { top: '70.85%', left: '47%' },
        { top: '74.90%', left: '47%' },

        { top: '38.50%', left: '22%' },
        { top: '42.55%', left: '22%' },
        { top: '46.60%', left: '22%' },
        { top: '52.65%', left: '22%' },
        { top: '56.70%', left: '22%' },
        { top: '60.75%', left: '22%' },
        { top: '66.80%', left: '22%' },
        { top: '70.85%', left: '22%' },
        { top: '74.90%', left: '22%' },
      ],
    };
  },
  methods: {
    buttonLocation(index) {
      if (this.storeState.data.deviceInfo.model === 48) {
        return this.buttonLocation48[index];
      }
      return this.buttonLocation12[index];
    },
    ctState(ct) {
      let state = 0;
      if (ct.unsaved && ct.active) {
        state = 0;
      } else if (!ct.unsaved && ct.active) {
        state = 1;
      } else if (ct.unsaved && !ct.active) {
        state = 2;
      } else if (!ct.unsaved && !ct.active) {
        state = 3;
      }
      return state;
    },
    buttonClass(ct) {
      let style = '';
      if (ct.unsaved && ct.active) {
        style += this.styles[0];
      } else if (!ct.unsaved && ct.active) {
        style += this.styles[1];
      } else if (ct.unsaved && !ct.active) {
        style += this.styles[2];
      } else if (!ct.unsaved && !ct.active) {
        style += this.styles[3];
      }

      style += ' transparent text--darken-2 ';
      return style;
    },
    compareInts(a, b) {
      if (Number(a) === Number(b)) {
        return true;
      }
      return false;
    },
    showCt(ct) {
      let matches = [];
      const search = ct + 6;
      this.storeState.data.loads.forEach((load) => {
        for (let i = 0; i < 3; i += 1) {
          if (load.cts[i].channel === search) {
            matches = matches.concat(load);
            this.ctPhase = i + 1;
          }
        }
      });

      if (matches[0]) {
        [this.selectedLoad] = matches;
      } else {
        this.selectedLoad = -1;
      }

      this.ctConfigured = this.storeState.data.allCts[ct].unsaved;
      this.storeState.selectedCt = JSON.parse(JSON.stringify(this.storeState.data.allCts[ct]));
      this.errors.clear();
      this.valid = this.ctConfigured;
    },
    unconfigure() {
      this.storeState.selectedCt.unsaved = false;
    },
    save() {
      // this.validate();
      this.$validator.validateAll()
        .then((isValid) => {
          if (!isValid) {
            this.storeState.selectedCt.unsaved = false;
          } else {
            // Dlete alarms related to this ct
            let proceedToDeleteAlarm = false;
            this.storeState.data.loads.forEach((load) => {
              for (let i = 0; i < 3; i += 1) {
                if (load.cts[i].channel === this.storeState.selectedCt.channel) {
                  if (load.cts[i].type !== this.storeState.selectedCt.type) {
                    proceedToDeleteAlarm = true;
                    break;
                  }
                }
              }
            });
            if (proceedToDeleteAlarm) {
              const delList = [];
              for (let i = 0; i < this.storeState.data.alarms.length; i += 1) {
                if (this.storeState.alarmTypes.find(t => t.value === this.storeState.data.alarms[i].type).ctApplicable) {
                  if (this.storeState.data.alarms[i].vinLineLoadOrCt === (this.storeState.selectedCt.channel - 6)) {
                    delList.push(i);
                  }
                }
              }
              delList.sort((a, b) => b - a);
              for (let index = 0; index < delList.length; index += 1) {
                this.deleteAlarm(this.storeState.data.alarms[delList[index]]);
              }
            }

            if (this.storeState.selectedCt.type !== 0) {
              this.storeState.selectedCt.unsaved = true;
            } else {
              this.storeState.selectedCt.unsaved = false;
            }
            const obj = JSON.parse(JSON.stringify(this.storeState.selectedCt));
            this.$set(this.storeState.data.allCts, this.storeState.selectedCt.channel - 6, obj);
            this.storeState.ctDirty = true;
            this.$store.updateVdis();
          }
        });
    },
    deleteAlarm(item) {
      const index = this.storeState.data.alarms.indexOf(item);
      if (index !== undefined) {
        this.storeState.data.alarms.splice(index, 1);
        for (let i = index; i < this.storeState.data.alarms.length; i += 1) {
          this.storeState.data.alarms[i].id -= 1;
        }
      }
      this.storeState.alarmsDirty = true;
    },
    copyDialog() {
      this.$validator.validateAll()
        .then((isValid) => {
          if (isValid) {
            if (this.storeState.selectedCt.type !== 0) {
              this.storeState.selectedCt.unsaved = true;
            } else {
              this.storeState.selectedCt.unsaved = false;
            }
            this.copyItems = [];
            Object.values(this.storeState.data.allCts).forEach((ct) => {
              // if (ct.unsaved === false) {
              this.copyItems.push({ text: `CT${ct.channel - 5}`, value: ct.channel });
              // }
            });
            this.$refs.copySelect.reset();
            this.dialog = true;
          }
        });
    },
    copySelect() {
      Object.values(this.selectedCopyCts).forEach((value) => {
        const ct = this.storeState.selectedCt;
        this.storeState.data.allCts[value - 6].type = ct.type;
        this.storeState.data.allCts[value - 6].typeName = ct.typeName;
        this.storeState.data.allCts[value - 6].inverse = ct.inverse;
        this.storeState.data.allCts[value - 6].unsaved = ct.unsaved;
        this.storeState.data.allCts[value - 6].maxRating = ct.maxRating;
        this.storeState.data.allCts[value - 6].maxOutput = ct.maxOutput;
        this.storeState.data.allCts[value - 6].phaseCorrection = ct.phaseCorrection;
      });
      this.dialog = false;
      this.storeState.ctDirty = true;
    },
    toggleSelection() {
      if (!this.copyAll) {
        this.selectedCopyCts = [];
        Object.values(this.copyItems).forEach((item) => {
          this.selectedCopyCts.push(item.value);
        });
      } else {
        this.selectedCopyCts = [];
      }
      this.copyAll = !this.copyAll;
    },
    clear() {
      this.storeState.selectedCt.unsaved = false;
      this.storeState.selectedCt.inverse = false;
      this.storeState.selectedCt.type = 0;
      this.storeState.selectedCt.typeName = 'None';
      this.valid = false;
      this.errors.clear();
    },
    closeCopySelect(clear) {
      if (clear) {
        this.selectedCopyCts = [];
      }
      this.$refs.select.isMenuActive = false;
    },
    updateTypeName() {
      if (this.storeState.selectedCt.phaseCorrection === undefined) {
        this.storeState.selectedCt.phaseCorrection = 0;
      }
      switch (this.storeState.selectedCt.type) {
        case 0:
          this.storeState.selectedCt.typeName = 'None';
          break;
        case 1:
          this.storeState.selectedCt.typeName = 'CTS-020 (20 Amp)';
          break;
        case 2:
          this.storeState.selectedCt.typeName = 'CTS-050 (50 Amp)';
          break;
        case 3:
          this.storeState.selectedCt.typeName = 'CTS-100 (100 Amp)';
          break;
        case 4:
          this.storeState.selectedCt.typeName = 'CTS-200 (200 Amp)';
          break;
        case 5:
          this.storeState.selectedCt.typeName = 'CTS-400 (400 Amp)';
          break;
        case 6:
          this.storeState.selectedCt.typeName = 'CT-PF-12 (1500 Amp)';
          break;
        case 7:
          this.storeState.selectedCt.typeName = 'CT-PF-24 (3000 Amp)';
          break;
        case 8:
          this.storeState.selectedCt.typeName = 'CT-PF-36 (6000 Amp)';
          break;
        default:
          this.storeState.selectedCt.typeName = '';
          break;
      }
    },
    setInitialSelectedCtWhenAvailable() {
      if (this.storeState.data.allCts.length !== 0) {
        this.storeState.selectedCt = JSON.parse(JSON.stringify(this.storeState.data.allCts[0]));
        this.$timer.stop('setInitialSelectedCtWhenAvailable');
      }
    },
  },
  mounted() {
    let ch = this.storeState.selectedCt.channel;
    if (ch === undefined) {
      if (this.storeState.data.allCts.length === 0) {
        this.$timer.start('setInitialSelectedCtWhenAvailable');
      } else {
        this.storeState.selectedCt = JSON.parse(JSON.stringify(this.storeState.data.allCts[0]));
      }
    } else {
      ch -= 6;
      this.storeState.selectedCt = JSON.parse(JSON.stringify(this.storeState.data.allCts[ch]));
    }
  },

  timers: {
    setInitialSelectedCtWhenAvailable: { time: 100, repeat: true, autostart: false },
  },
};
</script>
